import { IS_PRODUCTION, EFFECTIVE_HOSTNAME, CLIENT_ID } from './env'
export { DEBUG, CLIENT_ID, IS_DEV, IS_PRODUCTION } from './env'

const API = IS_PRODUCTION
    ? 'https://backend.bautvplus.de/graphql/'
    : 'https://backend.test.bautvplus.de/graphql/'

const KEYCLOAK = {
    REALM: IS_PRODUCTION
        ? 'netco'
        : 'netco-test',
    SERVER: IS_PRODUCTION
        ? 'https://login.bautvplus.de/'
        : 'https://login.test.bautvplus.de/',
    CLIENT_ID
}

const APP = {
    REDIRECT: IS_PRODUCTION
        ? 'https://projekte.bautvplus.de/app'
        : 'https://projekte.test.bautvplus.de/app',
    STORE: {
        GOOGLE: 'https://play.google.com/store/apps/details?id=de.netco.bautv',
        APPLE: 'https://apps.apple.com/de/app/bautv/id6740990801'
    }
}

const POWERTOOL = IS_PRODUCTION
    ? 'https://powertool.bautvplus.de'
    : 'https://powertool.test.bautvplus.de'

const AI_PARAMETERS = {
    AI_REPORT_ENABLED: 7,           // gates Dashboard "Object detection" tab
    ACCESS_MONITORING_ENABLED: 26,  // gates Access Monitoring
    PROJECT_REPORT_ENABLED: 27,     // gates Report
    CHATBOT_ENABLED: 28,            // gates Chatbot
    DASHBOARD_ENABLED: 29           // unused
}

const STATS = {
    HEADERS: { 'X-ET-Token': '0292d8eed7d238cb3cf9de9d337a1a29fde53bd2f1e0e111cee5f818749d5fec737948dd48052b119dba30b1023e5097' },
    SERVER: 'https://ws.etracker.com/api/v7/'
}

const WEATHER_CATEGORY = 'Wetter_vmnj94o85ztm49hg9v4' // db row in archive_picture_detail.kategorie

const LAYOUT = {
    WRAP_LIMIT: 10, // cameras per row before layout shifts
    PREVENT_ZOOM: false // global switch - disable zoom/pan on images
}

const BASEURL = `https://${EFFECTIVE_HOSTNAME}/` // in production BASEURL equals window.location.origin; in dev it points at the portal EFFECTIVE_HOSTNAME resolves to (for camera images)

// static skeleton — portalConfig.js merges the dynamic `protected` and `disabled` flags in and re-exports the complete ROUTES object
const ROUTES_STATIC = {
    HOME:      { id: 0, path: '/',          role: 'homePage' },
    LIVE:      { id: 1, path: '/live',      role: 'livePage' },
    TIMELAPSE: { id: 2, path: '/timelapse', role: 'timelapsePage' },
    ARCHIVE:   { id: 3, path: '/archive',   role: 'archivePage' },
    MYSITE:    { id: 4, path: '/mysite',    role: 'sitePage' },
    ACCESS:    { id: 5, path: '/access',    role: 'accessPage' }
}

export { API, KEYCLOAK, APP, POWERTOOL, AI_PARAMETERS, STATS, WEATHER_CATEGORY, LAYOUT, BASEURL, ROUTES_STATIC }